// Forgiving typing for languages with accents (French): a word typed without its accents or ligatures
// (ECOUTE, COEUR) counts as the one dictionary word it can stand for (ÉCOUTE, CŒUR). Opt in per language
// with `forgiveAccents` in i18n/languages.js.
import { LANGUAGE_BY_CODE } from '../i18n/languages';
import { upperWord } from './letters';

/** 'péché' -> 'peche', 'cœur' -> 'coeur': what a keyboard without accents produces. */
export function foldAccents(word) {
    return (word || '').toLowerCase().replace(/œ/g, 'oe').replace(/æ/g, 'ae')
        .normalize('NFD').replace(/\p{M}/gu, '');
}

const indexes = new WeakMap();

function foldIndex(dictionary) {
    let index = indexes.get(dictionary);
    if (!index) {
        index = new Map();
        for (const word of dictionary.words || []) {
            const key = foldAccents(word);
            if (key !== word) index.set(key, index.has(key) ? null : word);   // null = ambiguous
        }
        indexes.set(dictionary, index);
    }
    return index;
}

/** The word to play for what was typed: itself if it is a word, else its only accented twin, else itself. */
export function resolveTyped(typed, dictionary, language) {
    if (!typed || !dictionary || dictionary.has(typed) || !LANGUAGE_BY_CODE[language]?.forgiveAccents) {
        return typed;
    }
    const match = foldIndex(dictionary).get(foldAccents(typed));
    return match ? upperWord(match) : typed;
}
